import {Component, Inject, Injector, Input, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {Device} from 'projects/common/model/Device';
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

type InterlinkModuleResponse = {
    interlinks: InterLinksData[];
    with_card: boolean;
}

type InterLinksData = {
    text: string;
    link: string;
    image: string;
    type: string;
    review: string;
    icon: string;
};


@Component({
    selector: 'inter-link',
    template: `
        <div [ngClass]="(module.data.with_card ? 'eva-3-card -eva-3-shadow-line -eva-3-p-md' : '')" *ngIf="showModule">
            <tag-text class="-eva-3-mb-xlg" [data]="module.title"></tag-text>
            <div class="interlinks">
                <ul class="see-more-container interlinks-container">
                  <ng-container *ngFor="let interlink of module.data.interlinks; let i = index">
                    <li class="col" *ngIf="expanded || i < 4">
                      <a [href]="interlink.link" class="eva-3-link">
                        {{ interlink.text }}
                      </a>
                    </li>
                  </ng-container>

                </ul>
            </div>
            <div *ngIf="device.type !== 'DESKTOP'" class="see-more-button">
                <label *ngIf="!expanded" class="see-more eva-3-link" (click)="this.expanded = true ">
                    {{ 'offers.buttons.seeMoreOffers.true' | translate }} <i class="eva-icon eva-3-icon-chevron-down -eva-3-pl-sm"></i>
                </label>
                <label *ngIf="expanded" class="see-less eva-3-link" (click)="this.expanded = false ">
                    {{ 'offers.buttons.seeMoreOffers.false' | translate }}<i class="eva-icon eva-3-icon-chevron-up -eva-3-pl-sm"></i>
                </label>
            </div>
        </div>
    `,
    styleUrls: ['./inter-link.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InterLinkComponent extends AbstractComponent implements OnInit {
    public static MODULE_ID: string = 'InterLinkModule';
    @Input() override module: Module<InterlinkModuleResponse>;
    @Input() device: Device;
    @ViewChild('checkbox') checkbox;
    expanded = true;
    showModule: boolean;
    private readonly isBrowser: boolean;

    constructor(injector: Injector, @Inject(PLATFORM_ID) platformId: object) {
        super(injector);
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit() {
        this.expanded = this.device.type === 'DESKTOP';
        this.showModule = this.module?.data?.interlinks?.some(item => this.isNotEmpty(item));
        if (this.isBrowser && !this.showModule && this.module.unique_id) {
          document.getElementById(this.module.unique_id)?.classList?.add("-hidden");
        }
    }

    isNotEmpty = (interlink: InterLinksData) : boolean => {
      return Boolean(interlink.link && interlink.text);
    }

    getModuleId(): string {
        return InterLinkComponent.MODULE_ID;
    }
}
